import {
	getNotificationsHousesHouseIdNotificationsGetOptions,
	getNotificationsHousesHouseIdNotificationsGetQueryKey,
} from '@/client/@tanstack/react-query.gen';

/** Keep the drawer, property markers, and optimistic cache patch on the same query entry. */
export const NOTIFICATIONS_QUERY_LIMIT = 50;

export const notificationListQueryOptions = (houseId: number) =>
	getNotificationsHousesHouseIdNotificationsGetOptions({
		path: { house_id: houseId },
		query: { limit: NOTIFICATIONS_QUERY_LIMIT },
	});

export const notificationListQueryKey = (houseId: number) =>
	getNotificationsHousesHouseIdNotificationsGetQueryKey({
		path: { house_id: houseId },
		query: { limit: NOTIFICATIONS_QUERY_LIMIT },
	});
